<template>
  <div class="order advertiser">
    <head-panel title="广告主管理" subtitle="ADVERTISERS MANAGEMENT" :exportExc="false"></head-panel>
    <div class="oprPanel">
      <h3 class="subLabel">广告主管理</h3>
      <div class="selectBox clearfix">
        <label class="sel_lab fl">广告主筛选</label>
        <ny-select
          :data="advertiser.adTypeMenu"
          v-model="advertiser.curAdType"
          :keyValue="['value', 'name']"
          @change="changeSelect"
          part="adr"
          placeholder="请选择"
          class="advertiseSelect input_sm"
        ></ny-select>
        <el-input
          v-if="advertiser.curAdType !== 'industry_id'"
          class="searchBox"
          icon="search"
          v-model="adverName"
        ></el-input>
        <!-- <ny-select
          v-else
          :data="advertiser.industryMenu"
          v-model="adverName"
          :keyValue="['value', 'name']"
          @change="changeSelect"
          part="industryType"
          placeholder="请选择"
          class="advertiseSelect input_sm"
        ></ny-select>-->
        <ny-select
          v-if="advertiser.curAdType === 'industry_id'"
          :data="accountinfo.form.industryMenu"
          v-model="form.industryType"
          :keyValue="['id', 'name']"
          @change="({ value }) => changeIndustry({value: value, form:'form', isEdit: false })"
          type="industryType"
          placeholder="请选择"
          class="advertiseSelect input_sm mr20"
        ></ny-select>
        <ny-select
          v-if="advertiser.curAdType === 'industry_id'"
          :data="accountinfo.form.industrySecondMenu"
          v-model="form.industrySecondType"
          :keyValue="['id', 'name']"
          type="industryType"
          placeholder="请选择"
          class="advertiseSelect input_sm"
        ></ny-select>
        <el-button class="oprSuccess mr55" @click="searchData">搜索</el-button>
        <!--<div class="audit-radio">
          <p
            v-for="(item, index) in advertiser.total"
            :key="index"
            :class="{active: audit.active === item.verify}"
            @click="auditFilter(item.verify)"
          >{{advertiser.auditMenu[index].name}}{{item.total}}条</p>
        </div>-->
        <el-button class="oprSuccess fr add_order" @click="add_adver">
          <b>+&nbsp;</b>
          <i>新增广告主</i>
        </el-button>
      </div>
      <ny-table
        class="tableBox mt20"
        :page="advertiser.page"
        :pageFalse="true"
        @size-change="changePageSize"
        @current-change="changePageSize"
        v-loading="loading"
      >
        <template slot="operate" v-if="advertiser.page.data.length>0">
          <el-table-column label="操作" width="175" align="center">
            <template slot-scope="scope">
              <el-button
                @click="handleEdit(scope.$index, scope.row)"
                class="is-edit"
                type="primary"
                size="small"
              >编辑</el-button>
              <el-button
                @click="handleDelate(scope.$index, scope.row)"
                class="is-remove"
                type="primary"
                size="small"
              >删除</el-button>
            </template>
          </el-table-column>
        </template>
      </ny-table>
    </div>
  </div>
</template>

<script>
import { headPanel, NySelect, NyTable } from '@/global/components';
import { mapGetters } from 'vuex';
import { get } from '@/manager/http/index'
import { remove } from '../../http/index';
import IndustryMixns from '@/global/views/subAccount/industry.js'
export default {
  mixins: [IndustryMixns],
  name: 'advertiser',
  data () {
    return {
      get: get,
      adver: {
        value: ''
      },
      audit: {
        wait: 10,
        success: 15,
        refuse: 5,
        active: 0
      },
      form: {
        adverName: '',
        industrySecondType: '',
        industryType: ''
      },
      adverName: '',
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      advertiser: 'advertiser/advertiser',
      userid: 'login/userid'
    })
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      await this.$store.dispatch('advertiser/getAdType')
      // this.$store.dispatch('advertiser/getIndustryType')
      this.getTableInfo()
    },
    getTableInfo ({ currentPage, pageSize } = {}) {
      this.$store.dispatch('advertiser/getAdvertiserTable', {
        currentPage,
        pageSize,
        key: this.advertiser.curAdType,
        search: this.advertiser.curAdType === 'industry_id' ? this.form.industrySecondType : this.adverName
      })
    },
    changeSelect (val) {
      // console.log(val)
      // this.adverName = ''
    },
    changePageSize ({ currentPage, pageSize }) {
      this.getTableInfo({ currentPage, pageSize })
    },
    auditFilter (val) {
      if (this.audit.active === val) return false
      this.audit.active = val;
      this.advertiser.page.resetData()
      this.getTableInfo()
    },
    searchData () {
      this.advertiser.page.resetData()
      this.getTableInfo()
    },
    add_adver () {
      this.$router.push({ name: 'addAdvertiser' });
    },
    handleEdit (index, row) {
      this.$router.push({ name: 'editAdvertiser', params: { id: row.id } });
    },
    handleDelate (index, row) {
      let self = this
      this.$confirm('“确认删除广告主？”', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        remove('/admin/advertiser/' + row.id).then(res => {
          if (res.code === 1) {
            self.$message('删除成功')
            self.getTableInfo()
          }
        })
      })
    }
  },
  components: {
    headPanel,
    NySelect,
    NyTable
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
.advertiser {
  .sel_lab {
    line-height: 28px;
  }
  .add_order {
    width: 114px;
    b {
      float: left;
      font-size: 20px;
      font-weight: 600;
      margin-top: 0px;
    }
  }
  .priceCus {
    .el-dialog {
      width: 500px;
    }
  }
  .audit-radio {
    display: block;
    margin-top: 18px;
    p {
      display: inline-block;
      color: #ff0000;
      margin-right: 30px;
      cursor: pointer;
      font-size: 14px;
      line-height: 20px;
      border-bottom: 1px solid transparent;
      transition: all ease 0.4s;
    }
    .active {
      border-bottom: 1px solid #ff0000;
    }
  }
}
</style>
